var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 30,
    viewBox: "0 0 27 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4035 27.8998C20.456 24.8136 25.1797 19.7026 25.1797 13.4883C25.1797 6.86086 19.8071 1.48828 13.1797 1.48828C6.55227 1.48828 1.17969 6.86086 1.17969 13.4883C1.17969 19.7026 5.90332 24.8136 11.9558 27.8998C12.7249 28.2919 13.6345 28.2919 14.4035 27.8998Z",
    stroke: "#232222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.6797 13.4883C17.6797 15.9736 15.665 17.9883 13.1797 17.9883C10.6943 17.9883 8.67969 15.9736 8.67969 13.4883C8.67969 11.003 10.6943 8.98828 13.1797 8.98828C15.665 8.98828 17.6797 11.003 17.6797 13.4883Z",
    stroke: "#232222",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.e42d1ced1c2b9d8b57f72ee203de4c5b.svg";
export { ForwardRef as ReactComponent };